export default __webpack_public_path__ + "maps-examples-camera-animation-thumbnail-960-ad2b3c40b5c04bee37a768788e48a949.webp";